import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditHistoryRemarkDialogData } from 'src/app/components/aftale/models';

@Component({
    selector: 'app-edit-history-remark-dialog',
    templateUrl: './edit-history-remark-dialog.component.html',
    styleUrls: ['./edit-history-remark-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditHistoryRemarkDialogComponent implements OnInit {
  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<EditHistoryRemarkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditHistoryRemarkDialogData
  ) {}

  form: UntypedFormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      remark: new UntypedFormControl(this.data.currentRemark, Validators.required),
    });
  }

  cancel() {
    this.dialog.close(null);
  }

  save() {
    this.dialog.close(this.form.controls.remark.value);
  }
}
